/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

/**
 * Hygraph Media Domain for image processing
 * Falls back to default CMS assets domain if not configured
 */
export const HYGRAPH_MEDIA_DOMAIN = process.env.NEXT_PUBLIC_HYGRAPH_MEDIA_DOMAIN ?? "cms-assets.unrealengine.com";
